import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';
import JobCard from './JobCard';

const JobsToBeDone = props => (
  <div className={styles.jobsToBeDone}>
    <div className="container">
      <h1 className="navigator-title">Learn about Auth0</h1>

      <h2 className="header-description">
        Explore our most common use cases with a high-level overview and next steps
      </h2>
    </div>

    <div className={`container ${styles.jobsToBeDoneCards}`}>
      {props.jobs.map(job => <JobCard {...job} />)}
    </div>
  </div>
);

JobsToBeDone.defaultProps = {
  jobs: [
    {
      title: 'Add Login to Your App',
      description: 'Authenticate users and secure applications.',
      imageUrl: '/docs/img/add-login.png',
      articles: [
        {
          title: 'Native/Mobile App',
          url: '/docs/microsites/add-login/add-login-native-mobile-app'
        },
        {
          title: 'Single-Page App',
          url: '/docs/microsites/add-login/add-login-single-page-app'
        },
        {
          title: 'Regular Web App',
          url: '/docs/microsites/add-login/add-login-regular-web-app'
        }
      ]
    },
    {
      title: 'Call Your API',
      description: 'Obtain the tokens your application needs.',
      imageUrl: '/docs/img/call-api.png',
      articles: [
        {
          title: 'Native/Mobile App',
          url: '/docs/microsites/call-api/call-api-native-mobile-app'
        },
        {
          title: 'Single-Page App',
          url: '/docs/microsites/call-api/call-api-single-page-app'
        },
        {
          title: 'Regular Web App',
          url: '/docs/microsites/call-api/call-api-regular-web-app'
        },
        {
          title: 'Machine-to-Machine App',
          url: '/docs/microsites/call-api/call-api-m2m-app'
        },
        {
          title: 'Input-Constrained Device',
          url: '/docs/microsites/call-api/call-api-device'
        }
      ]
    },
    {
      title: 'Protect Your API',
      description: 'Protect your API endpoints from unauthorized access.',
      imageUrl: '/docs/img/protect-api.png',
      articles: [
        {
          title: 'Protect Your API with Auth0',
          url: '/docs/microsites/protect-api/protect-api'
        }
      ]
    },
    {
      title: 'Manage Your Users',
      description: 'Manage and customize user identity data.',
      imageUrl: '/docs/img/manage-users.png',
      articles: [
        {
          title: 'Manage Users and User Profiles',
          url: '/docs/microsites/manage-users/manage-users-and-user-profiles'
        },
        {
          title: 'Define and Maintain Custom User Data',
          url: '/docs/microsites/manage-users/define-maintain-custom-user-data'
        }
      ]
    }
  ]
};

JobsToBeDone.propTypes = {
  jobs: PropTypes.array.isRequired
};

export default JobsToBeDone;
